import { DefaultButton, Panel, Spinner, SpinnerSize, Stack } from '@fluentui/react';
import React from 'react';
import SearchSettingsForm from './SearchSettingsForm';
import { useGetSearchSettingsQuery, useSaveSearchSettingsMutation } from '../../../store/endpoints/SearchSettingsEndpoints';
import { ISearchSettings } from '../../../models/Settings';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/rootReducer';
import { useMsal } from '@azure/msal-react';

interface ISearchSettingsPanelProps {
    isOpen: boolean;
    onClose: () => void;
}

const SearchSettingsPanel: React.FC<ISearchSettingsPanelProps> = (props) => {
    const org = useSelector((state: RootState) => state.settings.selectedOrganization);
    const user = useMsal().accounts[0]?.username;
    const [updatedSettings, setUpdatedSettings] = React.useState<ISearchSettings>();
    const settings = useGetSearchSettingsQuery({org: org ?? '', user});
    const [saveSettings] = useSaveSearchSettingsMutation();
    const [saving, setSaving] = React.useState(false);

    React.useEffect(() => {
        if (settings.data) {
            setUpdatedSettings(settings.data);
        }
    }, [settings.data]);

    if (!props.isOpen) return null;

    const save = () => {
        if (!updatedSettings) return;
        setSaving(true);
        saveSettings({data: updatedSettings, org: org ?? '', user}).finally(() => {
            setSaving(false);
            props.onClose();
        });
    }

    return (
        <Panel
            isOpen={props.isOpen}
            onDismiss={props.onClose}
            headerText="Search Settings"
            closeButtonAriaLabel="Close"
            styles={{
                footer: {
                    backgroundColor: 'white'
                }
            }}
            isFooterAtBottom={true}
            onRenderFooterContent={() => (<Stack horizontal grow tokens={{childrenGap: '1em'}}>
                <DefaultButton primary onClick={save} text="Save" style={{ width: '100%'}} />
                <DefaultButton onClick={props.onClose} text="Close" style={{width: '100%'}} />
            </Stack>)}
            >
                {settings.isLoading || !updatedSettings
                ? (<Spinner size={SpinnerSize.large} label='Loading' labelPosition='bottom' />)
                : (
                    <SearchSettingsForm
                        settings={updatedSettings}
                        onChange={setUpdatedSettings}
                        disabled={saving}
                    />
                )}
        </Panel>
    );
};

export default SearchSettingsPanel;